import { render, staticRenderFns } from "./CaseOutcomeStatus.vue?vue&type=template&id=1c790658"
import script from "./CaseOutcomeStatus.vue?vue&type=script&lang=js"
export * from "./CaseOutcomeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports